import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";
import CardMedia from "../Media/CardMedia";
import { getReactHookFormNestedError } from "../../utils/errors";
import IconButtonAddContent from "../Buttons/IconButtonAddContent";
import { getPathDatabaseByRole } from "../../actions/auth";
import { useDispatchApp } from "../../lib/redux";
import { getUniqueID } from "../../utils/numbers";
import {
  BUTTON_CHANGE_CONTENT,
  BUTTON_SELECT_CONTENT,
} from "../../i18n/keysTranslations";
import TooltipOptimization from "../Tooltip/TooltipOptimization";
import ContentFieldAdaptivePreview from "./ContentFieldAdaptivePreview";

const ContentField = ({
  platform,
  name,
  label,
  propsSelectContentComponent = {},
  onCallbackSave = () => {},
  control,
  errors,
  rules,
  minDimensions = {},
  sxPreview = {},
  previewMode = "default",
  language,
  disabled = false,
  showTooltip = false,
  titleTooltip = "",
  actionTooltip = "",
  buttonTextChange = BUTTON_CHANGE_CONTENT,
  buttonTextSelectContent = BUTTON_SELECT_CONTENT,
  initialValuesAddContent = {},
}) => {
  const error = getReactHookFormNestedError(errors, name);

  const dispatch = useDispatchApp();
  const { userID } = dispatch(getPathDatabaseByRole());

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Box
          id={name}
          data-field={name}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography variant="body1" gutterBottom>
            {label}
          </Typography>
          {error?.message && (
            <Typography variant="caption" color="error" gutterBottom>
              {error?.message}
            </Typography>
          )}
          {field.value && previewMode === "carouselCard" ? (
            <ContentFieldAdaptivePreview
              url={field.value}
              sxPreview={sxPreview}
            />
          ) : null}
          {field.value && previewMode !== "carouselCard" ? (
            <CardMedia
              url={field.value}
              propsType={{
                controls: false,
                autoplay: false,
                loop: false,
              }}
              sx={{
                marginBottom: "8px",
                objectFit: "cover",
                borderRadius: 3,
                height: 360,
                width: "100%",
                ...sxPreview,
              }}
            />
          ) : null}
          <TooltipOptimization
            isOpen={showTooltip}
            titleTooltip={titleTooltip}
            actionTooltip={actionTooltip}
          >
            <Box>
              <IconButtonAddContent
                {...propsSelectContentComponent}
                id={`add-content-media-${getUniqueID()}`}
                mode="button"
                pathStorage={`adsCampaigns/${userID}/`}
                modeUpload="sync"
                onAddContent={(contents) => {
                  onCallbackSave({ from: "upload", content: contents[0] });
                }}
                onCallbackSaveAI={(videoData) =>
                  onCallbackSave({ from: "creatify", content: videoData })
                }
                onCallbackSaveCanva={(mediaUrl) =>
                  onCallbackSave({ from: "canva", content: { url: mediaUrl } })
                }
                initialValues={{
                  language,
                  platform,
                  ...initialValuesAddContent,
                }}
                minDimensions={minDimensions}
                multiple={false}
                urlContent={field.value}
                textButton={
                  field.value ? buttonTextChange : buttonTextSelectContent
                }
                color="secondary"
                disabled={disabled}
                sxButton={{
                  width: "100%",
                  mt: 1.5,
                }}
              />
            </Box>
          </TooltipOptimization>
        </Box>
      )}
    />
  );
};

export default ContentField;
